export enum StockProductsInPreparationStatusEnum {
  WAITING_FOR_DELIVERY = 'WAITING_FOR_DELIVERY',
  DELIVERED = 'DELIVERED',
}
